import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import { mapState } from 'vuex';
export default {
  fetch: function fetch(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var i18n, store, route, error, splitPath, path, statusCode;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              i18n = _ref.i18n, store = _ref.store, route = _ref.route, error = _ref.error;
              _context.prev = 1;
              splitPath = route.path.replace(/^\//, '').split('/');

              if (splitPath[0] === i18n.locale) {
                splitPath.splice(0, 1);
              }

              path = splitPath.join('/');
              _context.next = 7;
              return store.dispatch('getPage', path);

            case 7:
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              statusCode = _context.t0.response && _context.t0.response.status >= 500 ? 503 : 404;
              error({
                statusCode: statusCode,
                message: _context.t0.message
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }))();
  },
  computed: mapState(['page']),
  head: function head() {
    return {
      title: this.page.seo.title ? this.page.seo.title : this.page.title,
      meta: [this.page.seo.meta_description ? {
        hid: 'description',
        name: 'description',
        content: this.page.seo.meta_description
      } : {}, this.page.seo.meta_index !== 0 ? {
        hid: 'robots',
        name: 'robots',
        content: (this.page.seo.meta_follow ? 'follow ' : 'nofollow ') + (this.page.seo.meta_index ? 'index' : 'noindex')
      } : {}, this.page.seo.meta_title ? {
        hid: 'og:title',
        name: 'og:title',
        content: this.page.seo.meta_title
      } : {}, this.page.seo.meta_description ? {
        hid: 'og:description',
        name: 'og:description',
        content: this.page.seo.meta_description
      } : {}, this.page.image ? {
        hid: 'og:image',
        name: 'og:image',
        content: this.page.image
      } : {}]
    };
  }
};